import { render, staticRenderFns } from "./micro-learning.vue?vue&type=template&id=2e90e3d7&scoped=true&"
import script from "./micro-learning.vue?vue&type=script&lang=js&"
export * from "./micro-learning.vue?vue&type=script&lang=js&"
import style0 from "./micro-learning.vue?vue&type=style&index=0&id=2e90e3d7&lang=scss&scoped=true&"
import style1 from "./micro-learning.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e90e3d7",
  null
  
)

export default component.exports